import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Loop extends BaseOption {
  static userInterfaceComponent = {
    label: "Loop Video",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          icon: "mdi:repeat",
          tooltip: "Loop On",
          value: "Yes",
        },
        {
          icon: "mdi:repeat-off",
          tooltip: "Loop Off",
          value: "No",
        },
      ],
    },
  };

  static defaultValue = "No";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "Yes";
  }
}
